import React from "react";
import "./foodCategory.css";

// food card module
import SubCategoryCard from "./SubCategoryCard";

export default function SubCategories({ subCat }) { // receiving props

  return (
    <>
       <hr className="cat_hr_line" style={{width: "1120px"}}/>
      <div style={{ marginTop: "2rem" }} >
      <h1 style={{ width: "1150px", paddingLeft: "1.1rem", margin: "auto", fontFamily: "Poppins, sans-serif" }}>
          {/* conditional rendering */}
          The week's lunch {
            subCat.map(item => {
              return (
                <span key={ item._id}>{ item.title}</span>
              )
            })
          } menu
        </h1>
        <div className="subCat_container">
          {subCat.map((subItem, i) => {
            return <SubCategoryCard subItem={subItem.menu} key={i} />; // food card component listing through map array method
          })}
        </div>
      </div>
    </>
  );
}
